import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { denormalize } from 'normalizr';
import { Route, Switch } from 'react-router-dom';

import { SCHEMAS } from 'js/api';

import { logout } from 'js/actions/account-actions';
import {
  Header,
  Footer,
  AccountsSidebar,
  Sidebar,
  GuestSidebar,
  GlobalMessages,
  DashboardPageErrorBoundary,
} from 'js/components';
import {
  GuestAuthorization,
  FullUserAuthorization,
} from 'js/components/Security';
import { selectActiveWorkspace } from 'js/store/reducers/workspaces';
import { OnboardingProvider } from 'js/components/Onboarding';
import { useHistory } from 'react-router-dom';

const AuthorizedGuestSidebar = GuestAuthorization(GuestSidebar);
const AuthorizedSidebar = FullUserAuthorization(Sidebar);

function Dashboard({ component: Component, children, ...props }) {
  const history = useHistory();
  const { logout = () => {} } = props;

  const handleLogout = useCallback(() => {
    logout();
    history.push('/');
  }, [logout, history]);

  // Outside a workspace (account pages) there is no checklist to load.
  const workspaceId = props.activeWorkspace?.id;

  const layout = (
    <div className="wrapper">
      <Switch>
        <Route
          path="/a/:accountId"
          render={() => <AccountsSidebar {...props} user={props.me} />}
        />
        <Route
          path="/"
          render={() =>
            !!props.activeWorkspace && (
              <>
                <AuthorizedSidebar user={props.me} {...props} />{' '}
                <AuthorizedGuestSidebar user={props.me} {...props} />
              </>
            )
          }
        />
      </Switch>
      <div className="main-panel">
        <GlobalMessages {...props} />
        <Header {...props} onLogout={handleLogout} />
        <DashboardPageErrorBoundary layoutName="Dashboard">
          {Component ? <Component {...props}>{children}</Component> : children}
        </DashboardPageErrorBoundary>
        <Footer fluid />
      </div>
    </div>
  );

  return workspaceId ? (
    <OnboardingProvider
      workspaceId={workspaceId}
      initiallyVisible={props.me?.onboarding_visible !== false}
    >
      {layout}
    </OnboardingProvider>
  ) : (
    layout
  );
}

export default connect(
  (state) => {
    const { entities } = state;

    return {
      me: denormalize(state.identity.me, SCHEMAS.ME, entities),
      activeAccount: state.activeAccount,
      activeWorkspace: selectActiveWorkspace(state),
    };
  },
  { logout }
)(Dashboard);
